export default {
  "common": {
    "accessManagement": "Gestión de Acceso",
    "action": "Acción",
    "actions": "Acciones",
    "activate_link": "Activar enlace",
    "active": "Activo",
    "add_column": "Agregar columna",
    "add_dependency": "Agregar dependencia",
    "add_field": "Agregar campo",
    "add_group": "Agregar Grupo",
    "add_group_feature_description": "Seleccione el grupo que desea agregar a la funcionalidad",
    "add_group_feature_title": "Agregar grupo a la funcionalidad",
    "add_initiative": "Agregar iniciativa",
    "add_one_option_per_line": "Agregar una opción por línea",
    "add_option": "Agregar opción",
    "add_permission": "Agregar permiso",
    "add_question": "Agregar pregunta",
    "add_related_field": "Agregar campo relacionado",
    "add_row": "Agregar fila",
    "add_rule": "Agregar regla",
    "add_section": "Agregar sección",
    "add_to_group": "Agregar a un grupo",
    "add_user": "Agregar Usuario",
    "add_user_feature_description": "Seleccione el usuario que desea agregar a la funcionalidad",
    "add_user_feature_title": "Agregar usuario a la funcionalidad",
    "add_user_to_group": "Agregar usuario al grupo",
    "add_user_to_initiative": "Agregar usuario a la iniciativa",
    "add_workflow": "Agregar Workflow",
    "added_at": "Agregado el",
    "administrators": "Administradores",
    "alias": "Alias",
    "alias_format": "El alias debe comenzar con una letra minúscula o un guion bajo y contener solo letras minúsculas, números o guiones bajos",
    "alias_invalid_reserved_word": "Alias no válido. No puede ser una palabra reservada.",
    "alias_max_length": "El alias debe tener como máximo 100 caracteres",
    "alias_min_length": "El alias debe tener como mínimo 3 caracteres",
    "allow_others": "Agregar otros?",
    "and": "Y",
    "apply_rules": "Aplicar reglas",
    "attributes": "Atributos",
    "back_to_feature": "Volver a la Funcionalidad",
    "back_to_home": "Volver al inicio",
    "back_to_initiative": "Volver a la iniciativa",
    "begins_with": "Comienza con",
    "between": "Entre",
    "both_filters_cannot_be_empty": "Ambos filtros no pueden estar vacíos",
    "business": "Negocio",
    "business_created_successfully": "Negocio creado con éxito.",
    "business_data": "Datos del negocio",
    "business_name": "Nombre del negocio",
    "business_required": "El negocio es obligatorio",
    "business_updated_successfully": "Negocio actualizado con éxito.",
    "businesses": "Negocios",
    "cancel": "Cancelar",
    "cannot_remove_last_section": "No se puede eliminar la última sección",
    "cannot_save_empty_filter": "No se puede guardar un filtro vacío",
    "cannot_save_empty_form": "No se puede guardar formulario vacío",
    "change_password": "Cambiar contraseña",
    "change_user_password": "Cambiar contraseña del usuario",
    "change_user_password_description": "Cree una contraseña temporal para el usuario, que deberá ser cambiada en el próximo inicio de sesión.",
    "choose_an_attribute_from_the_list_above": "Elija un campo de la lista de arriba",
    "choose_field_from_table": "Elija un campo de la tabla de datos",
    "choose_layout_link": "Seleccione el diseño para el que desea crear el enlace:",
    "clean_unsaved_collect": "Limpiar recolección no guardada",
    "CNPJ_invalid": "El CNPJ informado es inválido.",
    "CNPJ_max_length_18": "El CNPJ debe tener como máximo 18 caracteres.",
    "CNPJ_min_length_18": "El CNPJ debe tener como mínimo 18 caracteres.",
    "CNPJ_required": "El CNPJ es obligatorio",
    "collect": "Recolección",
    "collect_back_button": "Anterior",
    "collect_concluded_button": "Concluir formulario",
    "collect_finished": "La recolección finalizó con éxito.",
    "collect_next_button": "Próxima sección",
    "collect_section_paginate": "Sección",
    "collect_section_paginate_separator": "de",
    "collect_versions": "Versiones de recolección",
    "collects": "Recolecciones",
    "column_size": "Tamaño de la columna",
    "condition": "Condición",
    "condition_contains": "Contiene",
    "condition_equal": "Igual",
    "condition_greater_than": "Mayor que",
    "condition_less_than": "Menor que",
    "condition_multiple": "Múltiple",
    "configurations": "Configuraciones",
    "configure_attribute": "Configurar atributo",
    "confirm": "Confirmar",
    "confirm_action": "Confirmar cambio de estado",
    "confirm_delete_feature": "¿Está seguro de que desea eliminar esta funcionalidad?",
    "confirm_password": "Confirme la contraseña",
    "confirm_remove_row_description": "¿Desea realmente eliminar esta línea? Los campos contenidos en ella serán eliminados.",
    "confirm_remove_section_description": "¿Desea realmente eliminar esta sección? Los campos que contiene serán eliminados.",
    "connect_question": "Conectar pregunta",
    "consent_text_min_length": "El texto de consentimiento debe tener como mínimo 5 caracteres.",
    "consent_text_required": "Es necesario informar el texto de consentimiento",
    "contains": "Contiene",
    "contains_file": "Contiene archivo",
    "CPF_invalid": "El CPF informado es inválido.",
    "CPF_min_length_11": "El CPF debe tener al menos 11 caracteres.",
    "create": "Crear",
    "create_business": "Crear Negocio",
    "create_field": "Crear campo",
    "create_group": "Crear grupo",
    "create_initiative": "Crear iniciativa",
    "create_user": "Crear usuario",
    "created_at": "Creado el",
    "created_by": "Creado por",
    "currency_symbol": "$",
    "custom_fields": "Campos personalizados",
    "customize_layout_attributes": "Personalizar diseño y atributos",
    "dashboard": "Dashboard",
    "dashboard_link": "Enlace del dashboard",
    "dashboard_link_placeholder": "https://app.powerbi.com/ejemplo",
    "data_collection": "Recolección de datos",
    "data_information": "Datos e información",
    "data_source": "Fuente de datos",
    "data_table": "Tabla de datos",
    "date_invalid": "La fecha debe estar en formato dd/mm/aaaa",
    "DateTime_invalid": "La fecha y hora deben estar en formato dd/mm/aaaa HH:mm",
    "deactivate_link": "Desactivar enlace",
    "define_super_admin_permissions": "Definir permisos de super admin",
    "delete": "Eliminar",
    "delete_attribute": "Eliminar atributo",
    "delete_collect": "¿Realmente desea eliminar esta colecta?",
    "delete_dependency": "Eliminar dependencia",
    "delete_feature": "Eliminar Funcionalidad",
    "delete_feature_confirmation_label": "Sí, entiendo y quiero eliminar esta funcionalidad",
    "delete_feature_warning": "Atención: Esta acción es irreversible. Todos los datos vinculados a esta funcionalidad se eliminarán permanentemente.",
    "delete_initiative": "Eliminar iniciativa",
    "delete_initiative_confirmation": "¿Desea realmente excluir esta iniciativa?",
    "delete_option": "Eliminar opción",
    "delete_permission": "¿Desea realmente eliminar este permiso?",
    "delete_workflow": "Eliminar workflow",
    "delete_workflow_description": "¿Está seguro de que desea eliminar este workflow?",
    "dependencies": "Dependencias",
    "dependencies_count_one": "dependencia ({{count}})",
    "dependencies_count_many": "dependencias ({{count}})",
    "dependencies_count_other": "dependencias ({{count}})",
    "description": "Descripción",
    "description_length_invalid": "La descripción debe tener al menos 1 carácter.",
    "description_max_length": "La descripción debe tener como máximo 5000 caracteres.",
    "Description_max_length_3_800": "La descripción debe tener entre 3 y 800 caracteres",
    "description_min_length": "La descripción debe tener al menos 1 carácter.",
    "description_min_length_3_800": "La descripción debe tener al menos 3 caracteres y como máximo 800 caracteres.",
    "description_required": "La descripción es obligatoria.",
    "destination_initiative_required": "Debe seleccionar una iniciativa de destino para duplicar.",
    "destination_required": "El destino es obligatorio",
    "disable_portfolio": "Deshabilitar portafolio",
    "do_you_really_want_to_remove_the_group": "¿Desea realmente eliminar el grupo?",
    "download_template": "Descargar plantilla",
    "draft_saved": "Borrador guardado",
    "drag_and_drop_file": "Arrastre y suelte el archivo",
    "duplicate_feature": "Duplicar Funcionalidad",
    "duplicate_initiative": "Duplicar Iniciativa",
    "duplicate_section_title": "Ya existe una sección con este título.",
    "edit": "Edición",
    "edit_and_delete": "Edición y Eliminación",
    "edit_feature": "Editar Funcionalidad",
    "edit_initiative": "Editar iniciativa",
    "edit_portfolio": "Editar portafolio",
    "edit_user": "Editar usuario",
    "email": "Correo electrónico",
    "email_body": "Cuerpo del correo",
    "email_invalid": "El email no es válido",
    "email_required": "El email es obligatorio",
    "empty_layout": "Diseño vacío",
    "enable_portfolio": "Habilitar portafolio",
    "enabled_required": "Es necesario indicar si el usuario está activo",
    "end": "Fin",
    "end_date": "Fecha de fin",
    "ends_with": "Termina con",
    "enter_email": "Ingrese el correo electrónico",
    "enter_email_body": "Ingrese el cuerpo del correo",
    "enter_field_description": "Ingrese una descripción para el campo",
    "enter_field_name": "Ingrese el nombre del campo",
    "enter_new_password": "Ingrese la nueva contraseña",
    "enter_option_name": "Ingrese el nombre de la opción",
    "equals": "Es igual a",
    "error": "Error",
    "exampleEmail {{verb}} {{feature}}": "El siguiente correo electrónico ya se envía de forma predeterminada, lo que escribas en este campo se enviará al final de este mensaje:\nSe ha {{verb}} una recolección con el ID # para la funcionalidad {{feature}}.",
    "executed_at": "Ejecutado el",
    "exit": "Salir",
    "export_data": "Exportación de datos",
    "export_data_success": "Solicitud de exportación realizada con éxito.",
    "export_files": "Exportar archivos de recolecciones",
    "exports": "Exportaciones",
    "feature": "Funcionalidad",
    "feature_created_successfully": "Funcionalidad creada con éxito.",
    "feature_data": "Datos de la Funcionalidad",
    "feature_enabled": "Funcionalidad Activa",
    "feature_name": "Nombre de la Funcionalidad",
    "feature_published": "Funcionalidad publicada",
    "feature_updated_error": "Error al actualizar la funcionalidad",
    "feature_updated_success": "Funcionalidad actualizada con éxito.",
    "features": "Funcionalidades",
    "field": "Campo",
    "field_created_successfully": "Campo creado con éxito.",
    "field_description_max_length": "La descripción debe tener como máximo 5000 caracteres.",
    "field_name_max_length": "El nombre del campo debe tener como máximo 250 caracteres.",
    "field_placeholder": "Campo...",
    "field_required": "El campo es obligatorio",
    "field_type_BIG_INT": "Número entero",
    "field_type_DATE": "Fecha",
    "field_type_DATETIME": "Fecha y hora",
    "field_type_DECIMAL": "Número decimal",
    "field_type_FILE": "Archivo",
    "field_type_GEOGRAPHICAL_MULTIPLE_POINT": "Múltiples puntos geográficos",
    "field_type_GEOGRAPHICAL_POINT": "Punto geográfico",
    "field_type_GEOGRAPHICAL_POLYGON": "Polígono geográfico",
    "field_type_GEOGRAPHICAL_ROUTE": "Ruta geográfica",
    "field_type_IMPORT_FIELD": "Importar una funcionalidad",
    "field_type_INFO_TEXT": "Texto informativo",
    "field_type_LONG_TEXT": "Texto largo",
    "field_type_MATRIZ": "Matriz",
    "field_type_MULTIPLE_LIST": "Caja de selección múltiple",
    "field_type_required": "Es necesario informar el tipo de campo",
    "field_type_TERM": "Término de consentimiento",
    "field_type_TEXT": "Texto corto",
    "field_type_TIME": "Hora",
    "field_type_UNIQUE_LIST": "Caja de selección única",
    "fields_to_export": "Campos a exportar",
    "file": "Archivo",
    "file_cannot_be_null_select_file": "El archivo no puede ser nulo. Por favor, seleccione un archivo para enviar.",
    "filter_business": "Filtrar por negocio",
    "filter_by_feature": "Filtrar por Funcionalidad",
    "finished_count": "Finalizadas",
    "finished_rate": "Tasa de Finalización",
    "generate_link": "Generar enlace",
    "generated_automatically": "Generado automáticamente",
    "greater_than_or_equal_to": "Mayor o igual a",
    "group": "Grupo",
    "group_added_successfully": "Grupo agregado con éxito.",
    "group_created_successfully": "Grupo creado con éxito.",
    "group_data": "Datos del grupo",
    "group_edited_successfully": "Grupo editado con éxito.",
    "group_name": "Nombre del grupo",
    "group_required": "El grupo es obligatorio",
    "groups": "Grupos",
    "if_the_answer_is": "Si la respuesta es",
    "image_exceeded_size_limit": "La imagen ha superado el límite de tamaño de {{size}}mb.",
    "import_data_success": "Importación de datos realizada con éxito.",
    "import_file": "Archivo de importación",
    "import_finish": "Concluir",
    "import_line_max_length": "Las líneas deben tener un máximo de 255 caracteres.",
    "import_options": "Importar opciones",
    "imported_data": "Importación de datos",
    "imports": "Importaciones",
    "inactive": "Inactivo",
    "info_text_min_length": "El texto de información debe tener como mínimo 1 carácter.",
    "info_text_required": "El texto de información es obligatorio",
    "initiative": "Iniciativa",
    "initiative_created_successfully": "Iniciativa creada con éxito.",
    "initiative_deleted_successfully": "Iniciativa excluida con éxito.",
    "initiative_edited_successfully": "Iniciativa editada con éxito.",
    "initiative_name": "Nombre de la iniciativa",
    "initiative_name_max_length": "El nombre de la iniciativa debe tener como máximo 50 caracteres.",
    "initiative_successfully_duplicated": "Iniciativa duplicada con éxito.",
    "initiatives": "Iniciativas",
    "Integer_invalid": "El entero es inválido",
    "invalid_email": "Correo electrónico inválido",
    "invalid_option": "Opción inválida",
    "layout_saved_successfully": "Layout guardado con éxito.",
    "less_than_or_equal_to": "Menor o igual a",
    "like_required": "El término de búsqueda es obligatorio",
    "link": "Vincular",
    "link_collect": "Vincular recolección",
    "link_feature": "Vincular funcionalidad",
    "link_features": "Vincular funcionalidades",
    "linked_features": "Funcionalidades vinculadas",
    "loading_layout": "Cargando diseño...",
    "location": "Localización",
    "logo": "Logo",
    "logo_required": "El logo es obligatorio",
    "lookup": "lookup",
    "main_fields": "Campos principales",
    "manage_groups_permissions": "Administre los grupos que tienen permisos sobre esta funcionalidad.",
    "manage_users_permissions": "Administre los usuarios que tienen permisos sobre esta funcionalidad.",
    "manage_users_with_admin_permissions": "Administre los usuarios que tienen permisos de administrador sobre esta iniciativa.",
    "matrices": "Matrizes",
    "matrix": "Matriz",
    "matrix_fields": "Campos de la matriz",
    "matriz_field": "Campo Matriz",
    "matriz-create": "Crear matriz",
    "matriz-delete": "Eliminar matriz",
    "matriz-update": "Actualizar matriz",
    "maximum_value": "Valor máximo",
    "min_value_cannot_be_greater_than_max_value": "El valor mínimo no puede ser mayor que el valor máximo",
    "minimum_value": "Valor mínimo",
    "mobile": "Móvil",
    "monetary_subtype_not_apply_to_text": "El subtipo monetario no se aplica al texto",
    "name": "Nombre",
    "name_max_length": "El nombre debe tener como máximo 100 caracteres",
    "name_max_length_100": "El nombre debe tener como máximo 100 caracteres",
    "name_min_length": "El nombre debe tener al menos 3 caracteres",
    "name_min_length_3": "El nombre debe tener al menos 3 caracteres",
    "name_required": "El nombre es obligatorio",
    "new_collect": "Nueva recolección",
    "new_export": "Nueva exportación",
    "new_feature": "Nueva funcionalidad",
    "new_import": "Nueva importación",
    "no": "No",
    "no_attribute_selected": "Ningún atributo seleccionado",
    "no_audits_found": "No se encontraron auditorías",
    "no_collect_found": "No se encontró ninguna recolección",
    "no_collect_links": "No existen enlaces de recolección para esta funcionalidad. Volviendo...",
    "no_data_found": "Ningún dato encontrado.",
    "no_exports_found": "Ninguna exportación encontrada.",
    "no_features_found": "Ninguna funcionalidad encontrada.",
    "no_fields_found": "No se encontraron campos",
    "no_group_permission": "Ningún grupo tiene permiso para esta funcionalidad.",
    "no_groups_found": "No se encontraron grupos",
    "no_imports_found": "Ninguna importación encontrada.",
    "no_initiatives_found": "No se encontraron iniciativas",
    "no_linked_features": "No hay funcionalidades vinculadas",
    "no_permission": "Sin permiso",
    "no_published_layout_redirect": "No hay ningún diseño publicado para esta funcionalidad. Redirigiendo...",
    "no_related_fields_found": "No se encontraron campos relacionados",
    "no_user_permission": "Ningún usuario tiene permiso para esta funcionalidad.",
    "no_users_found": "No se encontraron usuarios",
    "no_workflows_found": "No se encontraron flujos de trabajo",
    "not_authorized": "¡Acceso no autorizado!",
    "not_collect_found": "No se encontraron recolecciones",
    "not_contains": "No contiene",
    "not_equals": "No es igual a",
    "notification": "Notificación",
    "on_change_section": "Al cambiar la matriz de referencia o el tipo de sección, se perderá la configuración actual. ¿Está seguro?",
    "only_images_as_logo": "La empresa solo acepta imágenes de tipo .png, .jpeg, .gif o .webapp como logo.",
    "open_count": "Aperturas",
    "operator": "Operador",
    "operator_required": "El operador es obligatorio",
    "option": "Opción",
    "option_line_placeholder": "Ingrese una opción por línea",
    "option_name_required": "El nombre de la opción es obligatorio",
    "or": "O",
    "other": "Otros",
    "page_not_found": "Página no encontrada",
    "page_not_found_description": "La página que está buscando no existe.",
    "pagination": "Paginación",
    "participants": "Participantes",
    "password": "Contraseña",
    "password_changed_successfully": "Contraseña cambiada con éxito.",
    "password_max_length": "La contraseña debe tener como máximo 40 caracteres",
    "password_min_length": "La contraseña debe tener al menos 4 caracteres",
    "password_required": "La contraseña es obligatoria",
    "passwords_must_match": "Las contraseñas deben coincidir",
    "past": {
      "create": "creada",
      "delete": "eliminada",
      "update": "actualizada"
    },
    "permission": "Permiso",
    "permission_added_success": "Permiso agregado con éxito.",
    "permission_deleted_successfully": "Permiso eliminado con éxito.",
    "permissions_groups": "Permisos de Grupos",
    "permissions_user": "Permisos de Usuarios",
    "Phone_max_length_15": "El teléfono debe tener como máximo 15 caracteres",
    "Phone_min_length_14": "El teléfono debe tener al menos 14 caracteres",
    "placeholder_editor": "¡Escriba o pegue su contenido aquí!",
    "platform": "Plataforma",
    "Point_invalid": "El punto es inválido",
    "Point_invalid_range": "El punto está fuera de rango",
    "point_min_length_1": "Debe ser informado pelo menos un punto",
    "portfolio": "Portafolio",
    "preview_fields": "Campos de vista previa",
    "processing": "Procesando",
    "publish": "Publicar",
    "redo_collect": "Realizar otra recolección",
    "region_city_or_neighborhood ": "Región, ciudad o barrio",
    "registration": "Registro",
    "related_field": "Campo relacionado",
    "remove": "Eliminar",
    "remove_rule": "Eliminar regla",
    "remove_user": "¿Desea realmente remover el usuario?",
    "remove_user_from_group": "Eliminar usuario del grupo",
    "required_field": "¿Campo obligatorio?",
    "required_matrix": "¿Matriz obligatoria?",
    "response": "Respuesta",
    "response_value": "valor de la respuesta",
    "responsible_data": "Datos del responsable",
    "responsible_email": "Correo del responsable",
    "Responsible_email_invalid": "El correo del responsable es inválido",
    "Responsible_email_required": "El correo del responsable es obligatorio",
    "responsible_name": "Nombre del responsable",
    "responsible_name_max_length": "El nombre del responsable debe tener como máximo 100 caracteres",
    "Responsible_name_max_length_100": "El nombre del responsable debe tener como máximo 100 caracteres",
    "responsible_name_min_length": "El nombre del responsable debe tener al menos 3 caracteres",
    "Responsible_name_min_length_3": "El nombre del responsable debe tener al menos 3 caracteres",
    "Responsible_name_required": "El nombre del responsable es obligatorio",
    "responsible_phone": "Teléfono del responsable",
    "responsible_phone_max_length": "El teléfono del responsable debe tener como máximo 15 caracteres",
    "Responsible_phone_max_length_15": "El teléfono del responsable debe tener como máximo 15 caracteres",
    "responsible_phone_min_length": "El teléfono del responsable debe tener al menos 14 caracteres",
    "Responsible_phone_min_length_15": "El teléfono del responsable debe tener al menos 14 caracteres",
    "Responsible_phone_required": "El teléfono del responsable es obligatorio",
    "restore_unsaved_collect": "Se ha encontrado una recolección no guardada. ¿Desea restaurarla?",
    "return_previous_page": "Volver a la página anterior",
    "return_to_businesses_management": "Volver a la gestión de negocios",
    "return_to_destination": "Volver a {{destination}}",
    "return_to_group_management": "Volver a la gestión de grupos",
    "return_to_initiative": "Volver a la iniciativa",
    "return_to_initiative_management": "Volver a la gestión de iniciativas",
    "return_to_initiatives": "Volver a iniciativas",
    "return_to_initiatives_management": "Volver a la gestión de iniciativas",
    "return_to_user_management": "Volver a la gestión de usuarios",
    "save": "Guardar",
    "save_changes": "Guardar cambios",
    "saved": "Guardado",
    "saving": "Guardando...",
    "search_collects": "Buscar recolecciones",
    "search_features": "Buscar Funcionalidades",
    "search_groups": "Buscar grupos",
    "search_in_initiative": "Buscar en la iniciativa",
    "search_initiative": "Buscar iniciativa",
    "search_users": "Buscar usuarios",
    "section": "Sección",
    "section_image": "Imagen de la sección",
    "section_order": "Sección {{order}}",
    "section_required": "La sección es obligatoria",
    "section_title": "Título de la sección",
    "sections": "Secciones",
    "select": "Seleccionar",
    "select_a_feature": "Seleccione una funcionalidad.",
    "select_a_value": "Seleccionar un valor",
    "select_action_type": "Seleccione el tipo de acción",
    "select_all": "Seleccionar todos",
    "select_an_import_file": "Seleccione un archivo de importación.",
    "select_an_option": "Seleccionar una opción",
    "select_at_least_one_item": "Seleccione al menos un item",
    "select_at_least_one_option": "Seleccione al menos una opción",
    "select_attribute": "Seleccionar atributo",
    "select_collect_required": "Es necesario seleccionar una recolección",
    "select_condition": "Seleccione una condición",
    "select_condition_required": "La condición es obligatoria",
    "select_feature": "Seleccione una funcionalidad",
    "select_feature_required": "La funcionalidad es obligatoria",
    "select_features_to_link": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_field": "Seleccione un campo",
    "select_field_min_options": "El campo de selección debe tener al menos dos opciones.",
    "select_field_subtype": "Seleccione el subtipo",
    "select_field_type": "Seleccione el tipo de campo",
    "select_filters": "Seleccionar filtros",
    "select_group_placeholder": "Seleccione un grupo",
    "select_group_required": "El grupo es obligatorio",
    "select_initiative": "Seleccione una iniciativa",
    "select_initiative_required": "La iniciativa es obligatoria",
    "select_matriz_field": "Seleccione el campo matriz",
    "select_max_three_fields": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_permission": "Seleccione el permiso",
    "select_permission_level": "Seleccione el nivel de permiso",
    "select_platform_required": "La plataforma es obligatoria",
    "select_preview_fields_tooltip": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_the_group_you_want_to_add_the_user_to": "Seleccione el grupo al que desea agregar el usuario",
    "select_user": "Seleccione el usuario",
    "select_user_placeholder": "Seleccione un usuario",
    "select_user_required": "El usuario es obligatorio",
    "select_user_to_add_to_group": "Seleccione el usuario que desea agregar al grupo",
    "select_user_to_add_to_initiative": "Seleccione el usuario que desea agregar a la iniciativa",
    "selected_items": "elementos seleccionados",
    "self_applied_link": "Enlace de autoaplicación",
    "sensitive_data": "Dato sensible",
    "start": "Inicio",
    "start_date": "Fecha de inicio",
    "start_date_cannot_be_greater_than_end_date": "La fecha de inicio no puede ser mayor que la fecha de fin",
    "start_write_count": "Iniciadas",
    "status": "Estado",
    "status_feature_updated_successfully": "Estado de la funcionalidad {{featureName}} actualizado con éxito",
    "strict_section_navigate": "Navegación estricta entre secciones",
    "sub_type": "Subtipo",
    "subtype_CNPJ": "CNPJ",
    "subtype_CPF": "CPF",
    "subtype_MAIL": "Correo electrónico",
    "subtype_MONEY_VALUE": "Valor monetario",
    "subtype_PHONE": "Teléfono",
    "subtypes_not_apply_to_decimal": "Los subtipos no se aplican a decimal",
    "success": "Success",
    "successfully_duplicated": "Duplicado con éxito",
    "successfully_removed": "Eliminado con éxito",
    "super_admin": "Super administrador",
    "super_admin_business_required": "Indique el nivel de permiso del negocio",
    "super_admin_initiative_required": "Indique el nivel de permiso de la iniciativa",
    "super_admin_permissions": "Permisos de super admin",
    "super_admin_required": "Es necesario indicar si el usuario es super administrador",
    "super_admin_user_required": "Indique el nivel de permiso del usuario",
    "template_and_import": "Plantilla e importación",
    "text_max_length_255": "El texto debe tener como máximo 255 caracteres",
    "text_max_length_3000": "El texto debe tener como máximo 3000 caracteres",
    "text_min_length_1": "El texto debe tener al menos 1 carácter",
    "text_min_length_3": "El texto debe tener al menos 3 caracteres",
    "this_action_cannot_be_undone": "Esta acción no se puede deshacer.",
    "time_format_expected": "Formato de hora inválido",
    "Time_invalid": "La hora es inválida",
    "title_initiative_data": "Datos de la iniciativa",
    "trigger": "Disparador",
    "trigger_type": "Tipo de disparador",
    "trigger_type_required": "El tipo de disparador es obligatorio",
    "type": "Tipo",
    "type_required": "El tipo es obligatorio",
    "update": "Actualizar",
    "update_version": "Subir versión",
    "update_version_confirm_description": "¿Está seguro de que desea subir la versión de la funcionalidad? Esta acción puede agregar nuevas validaciones o eliminar campos previamente registrados.",
    "upload": "Subir",
    "user": "Usuario",
    "user_added_successfully": "Usuario agregado con éxito.",
    "user_created_successfully": "Usuario creado con éxito.",
    "user_data": "Datos del usuario",
    "user_edited_successfully": "Usuario editado con éxito.",
    "user_removed_from_group_successfully": "Usuario eliminado del grupo con éxito.",
    "user_required": "El usuario es obligatorio",
    "user_status": "Estado del usuario",
    "users": "Usuarios",
    "users_found": "No se encontraron usuarios",
    "valid_link_required": "Es necesario indicar un enlace válido",
    "valid_powerbi_link_required": "Es necesario indicar un enlace válido de Power BI",
    "value": "Valor",
    "value_must_be_a_number": "El valor debe ser un número",
    "value_required": "El valor es obligatorio",
    "version": "Versión",
    "view": "Visualización",
    "view_analytics": "Ver estadísticas",
    "view_version": "Ver versión",
    "view_workflow": "Visualizar workflow",
    "waiting": "Esperando",
    "web": "Web",
    "workflow_deleted_successfully": "Workflow eliminado con éxito",
    "workflows": "Workflows",
    "yes": "Sí",
    "you_can_create_link": "Puede crear un enlace público para recopilar respuestas en línea."
  },
  "initiative": {},
  "features": {},
  "translation": {}
} as const;
